import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { TranslateService } from 'ng2-translate';

import { EmployeeDetailsPage } from '../../employees/employee-details/employee-details';
import { EmployeeModal } from '../../../modals/select-employee/select-employee'

import { IProject, IEmployee } from '../../../model/top.model';

import { ProjectData } from '../../../providers/project-data';
import { EmployeeData } from '../../../providers/employee-data';

import { Gender, EditMode } from '../../../enums/enums'
import { TimeRegistrationData } from '../../../providers/time-registration-data';

@Component({
  selector: 'page-project-details',
  templateUrl: 'project-details.html'
})
export class ProjectDetailsPage {

  project: IProject;
  mode: EditMode;
  private gender = Gender;
  editMode = EditMode;
  private firstShow: boolean;
  formGroupProjectDetail: FormGroup;
  private canLeave: boolean;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private projectData: ProjectData,
    private employeeData: EmployeeData,
    private timeRegistrationData: TimeRegistrationData,
    private translate: TranslateService) {
    this.project = navParams.get("project");
    this.mode = navParams.get("editMode");

    if (!this.mode) {
      this.mode = this.editMode.browse;
    }
    this.canLeave = this.mode == this.editMode.browse;
    this.firstShow = true;
    this.initFormGroup();
  }

  ionViewWillEnter() {
    if (this.firstShow) {
      this.firstShow = false;
      return;
    }

    //reload project when returning from detail page
    this.projectData.getProject(this.project.project_id).then((project) => {
      this.project = project;
    });
    this.resetFormGroup();
  }


  ionViewCanLeave() {
    if (!this.canLeave && this.mode != this.editMode.browse) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('ARE_YOU SURE_LEAVE') + '?',
        subTitle: this.translate.instant('ALL_UNSAVED_LOST') + '!',
        buttons: [{
          text: this.translate.instant('NO')
        },
        {
          text: this.translate.instant('YES'),
          handler: data => {
            if (this.mode == this.editMode.edit) {
              this.cancel();
            } else {
              this.canLeave = true;
              this.navCtrl.pop();
            }
          }
        }]
      });
      alert.present();
      return false;
    }
  }

  initFormGroup() {
    let controlsConfig = {
      name: [this.project.name, Validators.required],
      hall: [this.project.hall, Validators.required],
      king_id: [this.project.king_id, Validators.required]
    };
    this.formGroupProjectDetail = this.formBuilder.group(controlsConfig);
  }

  resetFormGroup() {
    this.formGroupProjectDetail.reset({
      name: this.project.name,
      hall: this.project.hall,
      king_id: this.project.hall,
    });
  }

  edit() {
    this.mode = this.editMode.edit;
    this.canLeave = false;
  }

  download() {
    this.timeRegistrationData.downloadProjectTimeRegistrations(this.project.project_id, this.project.name);
  }

  save() {
    if (this.formGroupProjectDetail.valid) {
      // update Object
      this.project.name = this.formGroupProjectDetail.value.name;
      this.project.hall = this.formGroupProjectDetail.value.hall;
      this.project.king_id = this.formGroupProjectDetail.value.king_id;
      this.project.employeeIds = this.project.employees.map(employee => employee.employee_id);

      if (this.mode == this.editMode.new) {
        this.projectData.createProject(this.project).then((result) => {
          if (result == null) {
            // TODO show error toast
            throw new Error("Error save project-details");
          } else {
            // TODO show success toast
          }
        });
      } else {
        this.projectData.setProject(this.project).then((result) => {
          if (result == null) {
            // TODO show error toast
            throw new Error("Error save project-details");
          } else {
            // TODO show success toast
          }
        });
      }
      this.mode = this.editMode.browse;
      this.canLeave = true;
    } else {
      for (const field in this.formGroupProjectDetail.value) {
        const control = this.formGroupProjectDetail.get(field);
        // for now only mark all elements as touched
        control.markAsTouched();
      }
    }
  }

  cancel() {
    this.mode = this.editMode.browse;
    this.canLeave = true;
    this.resetFormGroup();
  }

  employeeTapped(event, employee: IEmployee) {
    employee.projects = [this.project];

    this.navCtrl.push(EmployeeDetailsPage, {
      employee: employee
    });
  }

  selectEmployees(event) {
    let agreementModal = this.modalCtrl.create(EmployeeModal, { project: this.project });
    agreementModal.present();
    agreementModal.onDidDismiss(selectedEmployeeIds => {
      if (selectedEmployeeIds) {
        this.project.employeeIds = selectedEmployeeIds;
        this.projectData.setProject(this.project).then((result) => {
          if (result == null) {
            // TODO show error toast
            throw new Error("Error save project-details [selectEmployees2]");
          } else {
            // TODO show success toast
            this.projectData.getProject(this.project.project_id).then((project) => {
              this.project = project;
            });
          }
        });
      }
    });
  }

  // deleteEmployee(event, employee: IEmployee) {
  //   let alert = this.alertCtrl.create({
  //     title: this.translate.instant('DELETE') + '?',
  //     subTitle: this.translate.instant('ARE_YOU SURE_DELETE', { value: '"' + employee.first_name + ' ' + employee.last_name + '"' }) + '?',
  //     cssClass: 'top-delete-alert',
  //     buttons: [{
  //       text: this.translate.instant('NO')
  //     },
  //     {
  //       text: this.translate.instant('YES'),
  //       handler: data => {
  //         // TODO refactor to delete employeeId
  //         // this.projectData.deleteEmployee(employee, this.project.uuid).then((result: Array<IProject>) => {
  //         //   // console.log(result);
  //         // });
  //       }
  //     }]
  //   });
  //   alert.present();
  // }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project-details/project-details.ts